class ct_error_wrapper extends HTMLElement {
  constructor() {
    super();
  }
  launchError(error) {
    this.innerText = error;
    this.style.bottom = "15px";
    setTimeout(() => {
      this.innerText = "";
      this.style.bottom = "-100%";
    }, 3000);
  }
}

customElements.define("ct-error-wrapper", ct_error_wrapper);